import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand } from '@angular/router';
import { AuthService } from './auth.service';
import { firstValueFrom } from 'rxjs';

export const authGuard: CanActivateFn = async (_, state) => {
	const authService = inject(AuthService);
	authService.storeRequestedUrl(state.url);

	try {
		// misschien hebben we nog een werkend refresh token liggen
		return await firstValueFrom(authService.refreshTokenIfNeeded());
	} catch (error) {
		// misschien ook niet
		return new RedirectCommand(authService.oauthUrlTree, {
			skipLocationChange: true,
		});
	}
};
